import React from 'react';
import {DropdownControlled} from '@homeaway/react-dropdown';
import {Link} from '@homeaway/react-localization-components';

export default class SearchSuggestion extends React.Component {
    constructor(props) {
        super(props);
    }

    renderSuggestion() {
        const suggestionList = [];
        const suggestions = this.props.softwareSuggestions;
        suggestions.forEach((suggestion, i) => {
            suggestionList.push(
                <li key={i} ><Link href="#" id={suggestion.systemId} name={suggestion.systemName} onClick={this.props.handleSoftwareSelect}>{suggestion.systemName}</Link></li>);
        });
        return suggestionList;
    }

    render() {
        return (
            <DropdownControlled
                label="Dropdown"
                srOnlyLabel
                customToggle={<div className="content-col"/>}
                id="suggestion-dropdown"
                open={this.props.displaySuggestions}
                onBlur={this.props.handleDropDownDismiss}
            >
                {this.renderSuggestion.call(this)}
            </DropdownControlled>
        );
    }
}
